import { render, staticRenderFns } from "./TestNoteForm.vue?vue&type=template&id=dfa0fcec"
import script from "./TestNoteForm.vue?vue&type=script&lang=js"
export * from "./TestNoteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfa0fcec')) {
      api.createRecord('dfa0fcec', component.options)
    } else {
      api.reload('dfa0fcec', component.options)
    }
    module.hot.accept("./TestNoteForm.vue?vue&type=template&id=dfa0fcec", function () {
      api.rerender('dfa0fcec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/note/TestNoteForm.vue"
export default component.exports